module.exports = __webpack_public_path__ + "img/vw-toggle.121c39fd.gif";